export const processSteps = [
  {
    code: "01",
    title: "Solder Paste Inspection",
    body: "A 3D SPI scanner verifies every gram of paste at 8µm Z-axis resolution before placement begins.",
  },
  {
    code: "02",
    title: "Automated Placement",
    body: "Dual-gantry pick-and-place lines stage 42,000 components per board at sub-mil accuracy.",
  },
  {
    code: "03",
    title: "Reflow Profiling",
    body: "Nitrogen-purged 12-zone reflow with closed-loop thermocouple feedback per panel.",
  },
  {
    code: "04",
    title: "X-Ray Validation",
    body: "100% BGA and QFN joints validated by automated X-ray, archived for 25-year traceability.",
  },
];

export const showcaseChapters = [
  {
    tag: "Cleanroom",
    title: "Inside a Class 7 cleanroom",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20cinematic%20view%20of%20engineer%20in%20white%20cleanroom%20suit%20examining%20high%20density%20green%20PCB%20board%20under%20bright%20task%20light%2C%20deep%20industrial%20background%2C%20warm%20copper%20amber%20accent%20lighting%2C%20premium%20editorial%20documentary%20photography%20with%20shallow%20depth%20of%20field%20and%20moody%20professional%20atmosphere&width=900&height=600&seq=showcase-card-01&orientation=landscape",
  },
  {
    tag: "Optical",
    title: "AOI inspection at 0.01mm",
    image:
      "https://readdy.ai/api/search-image?query=Macro%20detail%20of%20automated%20optical%20inspection%20machine%20scanning%20a%20freshly%20assembled%20surface%20mount%20PCB%20with%20red%20laser%20grid%20overlay%2C%20dark%20industrial%20backdrop%2C%20warm%20amber%20safety%20lighting%2C%20premium%20technical%20editorial%20photography%2C%20deep%20shadows%20and%20moody%20professional%20atmosphere&width=900&height=600&seq=showcase-card-02&orientation=landscape",
  },
  {
    tag: "Thermal",
    title: "Reflow soldering profile",
    image:
      "https://readdy.ai/api/search-image?query=Industrial%20reflow%20oven%20conveyor%20with%20freshly%20soldered%20green%20circuit%20boards%20emerging%20under%20warm%20amber%20heat%20glow%2C%20dark%20moody%20factory%20interior%2C%20premium%20documentary%20photography%20style%2C%20cinematic%20lighting%20with%20deep%20shadows%20and%20warm%20copper%20accent%20tones%2C%20editorial%20industrial%20feel&width=900&height=600&seq=showcase-card-03&orientation=landscape",
  },
];